module.exports = __webpack_public_path__ + "img/Flag_of_The_Gambia.51399c19.svg";